import { TAdFoxBannerProps, TAdFoxBannerTemplate } from '@cian/adfox-component';

export type ExtractAdfoxItem = {
  /** Полное HTML-тело шаблона adfox */
  outerHtml: string;
  /** Параметры шаблона adfox */
  data: TAdFoxBannerProps & TAdFoxBannerTemplate;
};

export interface IExtractAdfoxParams {
  /** HTML-контент */
  html: string;
  /** Коллекция параметров для шаблонов adfox */
  items: ExtractAdfoxItem[];
}

/**
 * 1. Извлекает из HTML шаблон adfox-баннера с параметрами
 * 2. Вырезает шаблон adfox-баннера из HTML и заменяет пустым div'ом (опционально)
 * @param html - исходный HTML
 * @param replaceHtml - вырезать ли шаблон adfox-баннера из HTML
 * @returns - Объект с исходным/измененным html и коллекцию параметров adfox-баннеров
 */
export const extractAdfoxParams = (html: string, replaceHtml: boolean = false): IExtractAdfoxParams => {
  const pattern = /<div[^>]*?(?:class="__adfox")>(.*?)<\/div>/gis;
  const items: ExtractAdfoxItem[] = [];
  let match;

  if (!html) {
    return {
      html: '',
      items: [] as ExtractAdfoxItem[],
    };
  }

  while ((match = pattern.exec(html))) {
    let parsedData;
    // Если парсинг сломался, то не добавляем в коллекцию
    try {
      parsedData = JSON.parse(
        match[1]
          .replace(/((\r)?\n)|\s/g, '')
          .replace(/(([\w]+):)/g, '"$2":')
          .replace(/'|(",(?:\}))/g, '"')
          .replace(/",\}/g, '"}'),
      );
    } catch (e) {
      parsedData = null;
    }

    if (parsedData) {
      items.push({
        outerHtml: match[0],
        data: parsedData,
      });
    }
  }

  return {
    html: replaceHtml
      ? items.reduce((acc, item) => {
          return acc.replace(item.outerHtml, `<div id="${item.data.containerId}" style="position: relative"></div>`);
        }, html)
      : html,
    items,
  };
};
